module.exports = __webpack_public_path__ + "static/media/NoeDisplay-Regular.47fdf632.woff";